import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import ScrollToTop from "./components/ScrollToTop";
import ReactGA from "react-ga4";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<BrowserRouter>
			<ScrollToTop />
			<Toaster
				position='top-center'
				toastOptions={{
					success: {
						style: {
							fontSize: "16px",
							marginTop: "14px",
							color: "white",
							background: "#3fb172",
							padding: "10px",
						},
					},
					error: {
						style: {
							fontSize: "16px",
							marginTop: "14px",
							color: "white",
							background: "#ff0000",
							padding: "10px",
						},
					},
				}}
			/>
			<App />
		</BrowserRouter>
	</React.StrictMode>
);

ReactGA.initialize("G-X05K5FK1RN");